import { actionTypes } from '../common/constants/actionTypes';

import CertificateContentPage from '../api/certificatesContentPageEntity';
import CompetencesContentPage from '../api/competencesPageEntity';
import ContentPage from '../api/contentPageEntity';
import VttError from '../api/vttError';

export const mainContentReducer = (state: any, action: any) => {
  switch (action.type) {
    case actionTypes.FETCH_CERTIFICATES_ITEMS_COMPLETED:
      const resultObject = handleFetchCertificateContentPageCompleted(state, action.payload);
      return resultObject;
    case actionTypes.FETCH_COMPETENCES_ITEMS_COMPLETED:
      const competencesPageResultObject = handleFetchCompetencesContentPageCompleted(state, action.payload);
      return competencesPageResultObject;
    case actionTypes.FETCH_CONTENT_PAGE_BY_ID_COMPLETED:
      const contentPageResultObject = handleFetchContentPageCompleted(state, action.payload);
      return contentPageResultObject;
    case actionTypes.SET_COOKIE_BANNER_VISIBILITY:
      const cookieBannerVisibilityObject = handleSetCookieBannerVisibility(state, action.payload);
      return cookieBannerVisibilityObject;
    case actionTypes.FETCH_CONTENT_PAGE_ERROR:
      const contentPageErrorObject = handleError(state, action.payload);
      return contentPageErrorObject;
  }

  if (state) {
    return state;
  }

  return {
    certificatesPageItem:  new CertificateContentPage(),
    competencesPageItem:   new CompetencesContentPage(),
    cookieBannerVisible:   false,
    currentContentPage:    new ContentPage(),
    errorDescription:      new VttError(),
  };
};

const handleFetchCertificateContentPageCompleted = (state: any, payload: CertificateContentPage) => ({
  certificatesPageItem: payload,
  cookieBannerVisible:  state.cookieBannerVisible,
  currentContentPage:   state.currentContentPage,
  errorDescription:     new VttError(),
});

const handleFetchCompetencesContentPageCompleted = (state: any, payload: CompetencesContentPage) => ({
  competencesPageItem: payload,
  cookieBannerVisible: state.cookieBannerVisible,
  currentContentPage:  state.currentContentPage,
  errorDescription:    new VttError(),
});

const handleSetCookieBannerVisibility = (state: any, payload: boolean) => ({
  certificatesPageItem: state.certificatesPageItem,
  cookieBannerVisible:  payload,
  currentContentPage:   state.currentContentPage,
  errorDescription:     state.errorDescription,
});

const handleFetchContentPageCompleted = (state: any, payload: ContentPage) => ({
  certificatesPageItem: state.certificatesPageItem,
  cookieBannerVisible:  state.cookieBannerVisible,
  currentContentPage:   payload,
  errorDescription:     new VttError(),
});

const handleError = (state: any, payload: VttError) => ({
  certificatesPageItem: state.certificatesPageItem,
  cookieBannerVisible:  state.cookieBannerVisible,
  currentContentPage:   state.currentContentPage,
  errorDescription:     payload,
});



// WEBPACK FOOTER //
// ./src/reducers/mainContent.ts